import { RemuneracaoMedica } from '@/types/core'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'GarantiaMinimaStore' })
export default class GarantiaMinimaStore extends VuexModule {
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  public pagina: number = 1
  public qtdPorPagina: number = 50
  public listaPrestadores: any[] = []
  selectedPrestador: string = ''
  selectedMesReferencia: string = ''
  showSuccessScreen: boolean = false
  showErrorScreen: boolean = false
  successList: any = {}
  errorList: any = []

  headers: any[] = [
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Status repasse', value: 'statusRepasse', sortable: false },
    { text: 'Valor total', value: 'valorTotalRepasse', sortable: false },
  ]

  @Mutation
  setListaPrestadores(listaPrestadores: any[]) {
    this.listaPrestadores = listaPrestadores
  }

  @Mutation
  setSelectedMesReferencia(mesReferencia: string) {
    this.selectedMesReferencia = mesReferencia
  }

  @Mutation
  setSelectedPrestador(prestador: string) {
    this.selectedPrestador = prestador
  }

  @Mutation
  setShowSuccessScreen(showSuccessScreen: boolean) {
    this.showSuccessScreen = showSuccessScreen
  }

  @Mutation
  setShowErrorScreen(showErrorScreen: boolean) {
    this.showErrorScreen = showErrorScreen
  }

  @Mutation
  setSuccessList(successList: any) {
    this.successList = successList
  }

  @Mutation
  setErrorList(errorList: any[]) {
    this.errorList = errorList
  }

  @Action
  async getListaPrestadores(nome?: string) {
    try {
      const response = await this.remuneracaoMedica.getListaPrestadores(nome)
      if (response.success) {
        this.context.commit('setListaPrestadores', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getCalcularGarantiaMinima() {
    try {
      const params: any = {
        mesAnoCompetencia: this.selectedMesReferencia ? `${this.selectedMesReferencia}-01` : null,
        prestadorId: this.selectedPrestador,
      }
      const response = await this.remuneracaoMedica.getCalcularGarantiaMinima(params)
      if (response.success) {
        if (response.data.sucessoGarantiaMinimaGlobalConfigurada) {
          this.context.commit('setShowErrorScreen', false)
          this.context.commit('setErrorList', [])
          this.context.commit('setShowSuccessScreen', true)
          this.context.commit('setSuccessList', response.data.garantiaMinimaGlobalRepasse)
        } else {
          this.context.commit('setShowSuccessScreen', false)
          this.context.commit('setSuccessList', {})
          this.context.commit('setShowErrorScreen', true)
          this.context.commit('setErrorList', response.data.garantiaMinimaGlobalRepasseInvalido)
        }
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async calcularGarantiaMinima() {
    try {
      const params: any = {
        mesAnoCompetencia: this.selectedMesReferencia ? `${this.selectedMesReferencia}-01` : null,
        prestadorId: this.selectedPrestador,
      }
      const response = await this.remuneracaoMedica.calcularGarantiaMinima(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
